import { useScriptTag } from '@vueuse/core';

type LanguageEditorReturn = {
    enable: (enable: boolean) => Promise<void>;
};

export function useLanguageEditor(): LanguageEditorReturn {
    const { load, unload } = useScriptTag('/scripts/crowdin.js', () => {
        useScriptTag('//cdn.crowdin.com/jipt/jipt.js', () => {
            console.info('LanguageEditor', 'Crowdin loaded');
        });
    }, { manual: true });

    async function enable(enable: boolean): Promise<void> {
        if (enable) {
            await load();
        } else {
            await unload();
        }
    }

    return { enable };
}
